import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext, useState } from 'react';
import api from 'services/api';

interface IResourceLink {
  onCancel: () => void;
  videoId: string;
  currentResource?: any;
  resourceData?: any[];
  setResourceData: any;
}

export default function ResourceLink({
  onCancel,
  videoId,
  currentResource,
  resourceData,
  setResourceData
}: IResourceLink) {
  const { hideModal } = useContext(ModalContext);
  const initialFormData = {
    description: currentResource?.description || '',
    resource_type: 'link',
    link: currentResource?.link || '',
    title: currentResource?.title || ''
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const hasFormChanged = () => {
    return JSON.stringify(initialFormData) !== JSON.stringify(formData);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (currentResource) {
      api.put(`api/videos/resource/${currentResource.hash_id}/`, formData).then((res) => {
        if (resourceData) {
          const newResourceList = resourceData.map((resource: any) => {
            if (resource.hash_id === res.data.hash_id) {
              return { ...resource, ...res.data };
            }
            return resource;
          });
          setResourceData(newResourceList);
        }
        onCancel();
      });
    } else {
      api.post(`api/videos/${videoId}/resource/`, formData).then((res) => {
        setResourceData((prevData: any) => [...prevData, res.data]);
        onCancel();
      });
    }
  };

  return (
    <div className="transparent font-lato">
      <form onSubmit={handleSubmit}>
        <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pt-9 px-7 w-screen md:w-[700px] md:min-h-[300px] rounded-t-lg">
          <div className="flex">
            <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Link details</span>
            <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
          </div>
          <div className="flex">
            <div className="flex-1">
              <p className="mb-1 font-bold mt-4">Link</p>
              <input
                type="url"
                id="link"
                name="link"
                value={formData['link']}
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-1 font-bold">Title</p>
              <input
                type="text"
                id="title"
                name="title"
                value={formData['title']}
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-1 font-bold">Description</p>
              <textarea
                className="border border-gray-300 rounded-md px-3 py-2 w-full"
                id="description"
                name="description"
                value={formData['description']}
                spellCheck="false"
                rows={5}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        <div className="flex text-[13px] py-6 px-7 bg-white rounded-b-lg border-x">
          <button
            className="py-3 px-6 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
            onClick={hideModal}
          >
            Cancel
          </button>
          <button
            className={`py-3 px-6 ml-2 rounded-[10px] ${
              hasFormChanged() ? 'bg-red-main text-white' : 'bg-gray-300 text-black'
            }`}
            type="submit"
            disabled={!hasFormChanged()}
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}
